import * as IconSelector from '../icons';

// Constantes exportadas
export const AUTH_DOCUMENT_AUTORIZACION = 'Autorizacion';
export const AUTH_DOCUMENT_DNI = 'DNI';
export const AUTH_DOCUMENT_PODERES = 'Poderes';
export const AUTH_DOCUMENT_ESCRITURA = 'Escritura';

// Definición del enum
export const authDocument = [
    {
        value: AUTH_DOCUMENT_AUTORIZACION,
        label: 'Autorización',
        description: 'Existe una autorización expresa',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: AUTH_DOCUMENT_DNI,
        label: 'DNI',
        description: 'Se ha aportado el DNI como autorizacion',
        icon: IconSelector.PointIcon,
        color: 'Green'
    },
    {
        value: AUTH_DOCUMENT_PODERES,
        label: 'Poderes',
        description: 'Se han emitido poderes',
        icon: IconSelector.PointIcon,
        color: 'DarkOrange'
    },
    {
        value: AUTH_DOCUMENT_ESCRITURA,
        label: 'Escritura',
        description: 'Se ha presentado la escritura',
        icon: IconSelector.PointIcon,
        color: 'Red'
    }
];
